module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2de90b55229f38c202115f7febd08f8b.png";